<template>
  <HeroView
      title="Mix"
      text="Feature-packed, advanced, and optimized for large-scale selling — with high-impact sales tools and conversion-driven design, built to grow profits and accelerate store expansion."
      purchase-link="https://themes.shopify.com/themes/mix/presets/mix"
      price="$380"
      img-main="/assets/imgs/themes/mix/hero/hero@2x.webp"
      img-set="/assets/imgs/themes/mix/hero/hero.webp 1x, /assets/imgs/themes/mix/hero/hero@2x.webp 2x"
      img-alt="Mix Shopify theme hero section design for conversion"
  />

  <DemosView
      title="5 Conversion-Driven <br>Pre-Built Presets"
      text="Explore 5 powerful presets — engineered to boost sales and produce real results with proven layouts and features."
      theme-id="mix"
  />
  <SubscribeSection theme="Mix" :id="3"/>
  <BannerView
      title="Turn Your Store Into a Conversion Machine"
      text="Maximize sales and engagement by turning your store into a high-converting experience. Every element is designed to guide visitors smoothly from discovery to checkout."
      purchase-link="https://themes.shopify.com/themes/mix/presets/mix"
      price="$380"
      img-main="/assets/imgs/themes/mix/banner@2x.webp"
      img-set="/assets/imgs/themes/mix/banner.webp 1x, /assets/imgs/themes/mix/banner@2x.webp 2x"
      img-alt="Promotional banner section for Mix Shopify theme"
  />
  <FeaturesView/>
  <SubscribeSection theme="Mix" :id="1"/>
  <BuiltView/>
  <DocView
      docUrl="https://ashstonestudios.zendesk.com/hc/en-us/categories/32095281194130"
  />
  <SubscribeNewsletterView theme="Mix" :id="2"/>
  <FinalView
      title="Conversion Magic Starts with Mix"
      text="Whether you’re launching a new brand or scaling an existing store, Mix is your secret weapon for turning traffic into loyal customers."
      purchase-link="https://themes.shopify.com/themes/mix/presets/mix"
      price="$380"
      img-main="/assets/imgs/themes/mix/final@2x.webp"
      img-set="/assets/imgs/themes/mix/final.webp 1x, /assets/imgs/themes/mix/final@2x.webp 2x"
      img-alt="Mix Shopify theme final storefront and UI preview"
  />
</template>

<script>
import HeroView from '@/components/general/HeroView.vue'
import DemosView from '@/components/general/DemosView.vue'
import BannerView from '@/components/general/BannerView.vue'
import FeaturesView from '@/components/general/FeaturesView.vue'
import BuiltView from '@/components/general/BuiltView.vue'
import DocView from '@/components/general/DocView.vue'
import FinalView from '@/components/general/FinalView.vue'

export default {
  name: 'MixView',
  components: {
    HeroView,
    DemosView,
    BannerView,
    FeaturesView,
    BuiltView,
    DocView,
    FinalView
  }
}
</script>

<script setup>
import { useHead } from '@vueuse/head'
import SubscribeNewsletterView from "@/components/SubscribeNewsletterView.vue";
import SubscribeSection from "@/components/SubscribeSection.vue";

useHead({
  title: 'Mix – Conversion-Optimized Shopify Theme',
  meta: [
    { name: 'description', content: 'Mix is a feature-packed, sales-optimized Shopify theme with high-impact conversion tools and advanced design, built to grow profits and scale your store.' },

    { property: 'og:title', content: 'Mix – Feature-Packed & Advanced Shopify Theme' },
    { property: 'og:description', content: 'Shopify theme built for fast conversion and a bold visual approach. Ideal for tech and small catalogs, featuring sticky product forms and advanced filtering.' },
    { property: 'og:image', content: '/assets/imgs/themes/mix/og_image.png' },
    { property: 'og:url', content: 'https://creativecommercelabs.com/themes/mix' },
    { property: 'og:type', content: 'website' },
    { property: 'og:locale', content: 'en_US' },
    { property: 'og:site_name', content: 'Mix' }
  ]
})
</script>
